import React from 'react';
import BreakoutGame from '../components/BreakoutGame';
import styles from './BreakoutPage.module.css';

const BreakoutPage: React.FC = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Breakout</h1>
      <div className={styles.gameContainer}>
        <BreakoutGame />
      </div>
    </div>
  );
};

export default BreakoutPage; 